import Cookie from 'js-cookie';
import Types from './Types';

const INITIAL_STATE = {
    userData: {},
    isLoading: false
};

export default function user(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_USER_DATA_SUCCESS: {
            return {
                ...state,
                userData: payload.data,
            };
        }



        // Misc
        case Types.SET_USER_IS_LOADING: {
            const isLoading = payload;
            return {
                ...state,
                isLoading: isLoading
            };
        }

        default: {
            return state;
        }
    }
}
